import script from "./CircuitCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CircuitCard.vue?vue&type=script&setup=true&lang=ts"

import "./CircuitCard.vue?vue&type=style&index=0&id=b87ec0b8&lang=css"

const __exports__ = script;

export default __exports__